import React from 'react'
import ReactMarkdown from 'react-markdown'
import { formatTime } from '../lib/support'

const markdownComponents = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  ul: ({ children }) => <ul className="mb-2 ml-4 list-disc last:mb-0">{children}</ul>,
  ol: ({ children }) => <ol className="mb-2 ml-4 list-decimal last:mb-0">{children}</ol>,
  li: ({ children }) => <li className="mb-0.5">{children}</li>,
  code: ({ children }) => <code className="rounded bg-black/5 px-1 py-0.5 text-xs">{children}</code>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary-700 underline hover:opacity-80">
      {children}
    </a>
  ),
}

/** Customer bubbles right (sky-600), assistant left (slate-50, markdown). */
export const ChatTranscript = ({ messages = [], showRole = false, maxWidth = 'max-w-[75%]' }) => (
  <>
    {messages.map((msg, i) => {
      const isUser = msg.role === 'user'
      return (
        <div key={msg.id ?? i} className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
          <div
            className={`${maxWidth} rounded-lg px-3 py-2 text-[13px] ${
              isUser ? 'bg-primary-600 text-white' : 'bg-admin-50 text-admin-900'
            }`}
          >
            {isUser ? (
              <p className="whitespace-pre-wrap">{msg.content}</p>
            ) : (
              <ReactMarkdown components={markdownComponents}>{msg.content}</ReactMarkdown>
            )}
            <div className="mt-1 text-[11px] opacity-70">
              {showRole ? `${isUser ? 'Cliente' : 'Assistente'} · ` : ''}
              {formatTime(msg.created_at)}
            </div>
          </div>
        </div>
      )
    })}
  </>
)

export { markdownComponents }
